class Eyetracker {
  constructor(canvas_parent, test_platform) {
    this.canvas_parent = canvas_parent;
    this.test_platform = test_platform;
    this.canvas = document.createElement("canvas");
    this.context = this.canvas.getContext("2d");
    this.canvas.setAttribute(
      "style",
      "position: absolute; left: 0px; pointer-events: none;"
    );
    this.mouse_history = [];

    this.canvas.width = canvas_parent.getBoundingClientRect().width;
    this.canvas.height = canvas_parent.getBoundingClientRect().height;
    this.ratio_x = 1920 / this.canvas.width;
    this.ratio_y = 1080 / this.canvas.height;
    canvas_parent.appendChild(this.canvas);
    this.context.fillRect(0, 0, this.canvas.width, this.canvas.height);
    this.context.lineJoin = this.context.lineCap = "round";
    this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
  }

  to_ratio(positions) {
    for (let i = 0; i < positions.length; i++) {
      if (this.test_platform === "mobile") {
        positions[i].ratio_x = parseInt((positions[i].x + 710) / this.ratio_x);
      } else {
        positions[i].ratio_x = parseInt(positions[i].x / this.ratio_x);
      }
      positions[i].ratio_y = parseInt(positions[i].y / this.ratio_y);
    }
    return positions;
  }
  draw(positions) {
    if (positions == 0) {
      return;
    }
    this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
    this.mouse_history = this.to_ratio(positions);

    let line_opacity = 0;
    let line_opacity_step = 0.8 / this.mouse_history.length;

    for (var i = 0; i < this.mouse_history.length; i++) {
      var radius_raw = 0;
      if (i == 0) {
        radius_raw = 0;
      } else {
        let distance = this.distanceBetween(
          this.mouse_history[i - 1],
          this.mouse_history[i]
        );
        if (distance < 1) {
          distance = 1;
        }
        radius_raw = this.canvas.width / distance;
      }
      var radius = this.mapRange(
        radius_raw,
        0,
        this.canvas.width,
        this.canvas.width / 50,
        this.canvas.width / 20
      );

      this.context.beginPath();
      this.context.globalAlpha = line_opacity;
      this.context.arc(
        this.mouse_history[i].ratio_x,
        this.mouse_history[i].ratio_y,
        radius,
        false,
        Math.PI * 2,
        false
      );

      let x = this.mouse_history[i].ratio_x;
      let y = this.mouse_history[i].ratio_y;

      var radgrad = this.context.createRadialGradient(
        x,
        y,
        radius / 2,
        x,
        y,
        radius
      );

      radgrad.addColorStop(0, "rgba(251,49,49,1");
      radgrad.addColorStop(0.5, "rgba(251,49,49,0.2)");
      radgrad.addColorStop(1, "rgba(251,49,49,0.1)");

      this.context.fillStyle = radgrad;
      this.context.fill();
      line_opacity += line_opacity_step;
    }
  }
  mapRange(value, low1, high1, low2, high2) {
    return low2 + ((high2 - low2) * (value - low1)) / (high1 - low1);
  }
  distanceBetween(point1, point2) {
    return Math.sqrt(
      Math.pow(point2.ratio_x - point1.ratio_x, 2) +
        Math.pow(point2.ratio_y - point1.ratio_y, 2)
    );
  }
  angleBetween(point1, point2) {
    return Math.atan2(
      point2.ratio_x - point1.ratio_x,
      point2.ratio_y - point1.ratio_y
    );
  }
}

export default Eyetracker;
